<template>
    <div class="banner banner--theme banner--split banner-colour">
        <div class="banner-primary">
            <div class="container">

                <div class="col-content">
                    <div class="banner-content">
                        <div class="heading-holder">
                            <h1>{{data.title}}</h1>
                            <div v-if="data.allowFavourites" @mouseover.self="tooltipinfoHoverIn($event, 'Add to Moodboard')" @mouseleave.self="tooltipinfoHoverOut($event)" ref="addFav" class="fav add-fav" :data_id="data.key" :class="data.isFavorite" @click="addFav(data.key)" data-category="MoodBoard" data-action="Click" data-label="Heart"></div>
                            <div v-if="data.allowFavourites" @mouseover.self="tooltipinfoHoverIn($event, 'Remove from Moodboard')" @mouseleave.self="tooltipinfoHoverOut($event)" ref="removeFav" class="fav remove-fav" :class="data.isFavorite " @click="removeFav(data.key)" data-category="MoodBoard" data-action="Click" data-label="Heart"></div>
                        
                        </div>
                        <colour-card v-if="data.colour" :data="data.colour" />

                        <p v-html="data.content"></p>
                        <img v-if="data.icon" :src="data.icon" :alt="data.title">

                        
                        <a class="button button--solid-black banner-colour-cta" :href="data.primaryLink" :aria-label="data.primaryLabel" :title="data.primaryLabel">{{data.primaryLabel}}</a>
                        <a class="button button--clear-black banner-colour-cta" :href="data.secondaryLink" :aria-label="data.secondaryLabel" :title="data.secondaryLabel">{{data.secondaryLabel}}</a>
                    </div>
                </div>

                <div class="col-image">
                    <div class="project-image" :style="{ backgroundImage: data.image ? 'url(' + data.image + ')' : 'initial' }"></div>
                    <div v-if="data.featureimageone" class="project-feature-1" :style="{ backgroundImage: 'url(' + data.featureimageone + ')' }"></div>
                    <div v-if="data.featureimagetwo" class="project-feature-2" :style="{ backgroundImage: 'url(' + data.featureimagetwo + ')' }"></div>
                </div>


            </div>
            
        </div>
    </div>
</template>

<script>

    import { Colour } from "../../components";
    import ColourCard from "../../components/Cards/ColourCard";
    import axios from 'axios';

    export default {
        name: "banner-colour",
        components: {
            Colour,
            ColourCard
        },
        props: {
            data: {
                type: Object
            }
        },
        data() {
            return {

            };
        },
        computed: {

        },
        methods: {
            
        addFav (id) {
            console.log(id);
            
            // this.$el.querySelector(".add-fav").classList.add('selected');
            // this.$el.querySelector(".remove-fav").classList.add('selected');
            const e1 = this.$el.querySelector(".add-fav").classList;
            const e2 = this.$el.querySelector(".remove-fav").classList;

            e2.add('d-block');
            e2.add('opacity-none');
            setTimeout(() => {
                e2.add('opacity-one');
                e2.remove('opacity-none');
            }, 25);
            setTimeout(() => {
                e1.add('selected');
                e2.add('selected');

                e2.remove('d-block');
                e2.remove('opacity-one');
            }, 275);


            axios.get(`/moodboardapi/item/${id}/toggle/?${Date.now()}`)
                .then(response => {
                    const message = {
                        title: 'Item added to moodboard',
                        text: '<a href="/inspiration/mood-board/">Item added to moodboard</a>',
                    }
                    
                    this.appendtoNotification(message);
                    this.toggleNotificationMoodboard();
                })
                .catch(error => {
                    console.log(error);
                })
            

        },

        removeFav (id) {

            // this.$el.querySelector(".add-fav").classList.remove('selected');
            // this.$el.querySelector(".remove-fav").classList.remove('selected');
            const e1 = this.$el.querySelector(".add-fav").classList;
            const e2 = this.$el.querySelector(".remove-fav").classList;

            e1.remove('selected');
            e2.add('d-block');
            e2.add('opacity-one');
            setTimeout(() => {
                e2.add('opacity-none');
                e2.remove('opacity-one');
            }, 25);
            setTimeout(() => {
                e2.remove('selected');
                e2.remove('opacity-one');
                e2.remove('d-block');
            }, 275);


            var classes = this.$el.querySelector(".remove-fav").classList;
            var classStr = classes.value;
            var hasRemove = classStr.includes("fav remove-fav remove");

            
            this.$el.classList.add('fade-out');
            axios.get(`/moodboardapi/item/${id}/toggle/?${Date.now()}`)
                .then(response => {
                    const message = {
                        title: 'Item removed from moodboard',
                        text: '<a href="/inspiration/mood-board/">Item removed from moodboard</a>',
                    }
                    
                    this.appendtoNotification(message);
                    this.toggleNotificationMoodboard();
                })
                .catch(error => {
                    console.log(error);
                })

        },
        },
        mounted() {

        }
    };
</script>

<style lang="scss" scoped>
    @import "../../../scss/abstracts/variables";

    .banner--split {
        position: relative;
        //max-height: auto;
        //max-height: 380px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        //background-color: $brand-blue;
        margin-top:120px;
        margin-bottom:100px;

        @media #{$lg} {
            //max-height: 380px;
             margin-top:160px;
             margin-bottom:130px;
        }

        .container {
            display: block;

            @media #{$lg} {
                display: flex;
                align-items: flex-start;
            }

            .col-content {
                width: 100%;
                display: block;

                @media #{$lg} {
                    width: 45%;
                    display: flex;
                }

                .banner-content {
                    max-width: 100%;
                    margin-top: 0;
                    padding-right: 0;

                    @media #{$lg} {
                        max-width: 650px;
                        padding-right: 2rem;
                    }

                    h1{
                        
                        font-family: "Untitled Sans Medium";

                        font-size:16px;
                        line-height:30px;

                        @media #{$lg} {
                            font-size: 28px;
                            line-height: 40px;
                        }

                    }
                    
                }

                .banner-content:deep(.colour-card .info .title) {
                    display: none;

                }

                .banner-content:deep(.colour-card .colour-sample-selector) {
                    pointer-events: none;

                }

                .banner-content:deep(.colour-card) {
                    display:flex;
                    align-items: center;

                     @media #{$lg} {
                        margin-top:30px;
                        display:block;

                     }


                }

                 .banner-content:deep(.colour-card .colour-circle--large) {
                    width:92px;
                    height:92px;

                    @media #{$lg} {
                        width:150px;
                        height:150px;
                    }

                }
            }

            .col-image {
                width: 100%;
                position: relative;
                right: 0;
                bottom: 0;
                // min-height: 320px;
                // max-height: 320px;
                overflow: visible;
                margin:0;

                @media #{$lg} {
                     margin: 0 -2rem;
                    width: 50%;
                    // position: absolute;
                    // min-height: calc(100% - 130px);
                    // max-height: calc(100% - 130px);
                    margin: auto;
                }

                .project-image {
                    width: 100%;
                    padding-bottom:100%;
                    // background-color: $brand-dark-grey;
                    background-size: contain;
                    background-position: top;
                    background-repeat: no-repeat;
                    position: relative;


                   


                    
                }
                .project-details {
                    display: flex;
                    border-bottom: 1px solid;
                    padding: 2rem 0;
                    flex-direction: row;

                    .project-details--col {
                        line-height: 34px;

                        &:first-of-type {
                            margin-right: 4rem;
                        }

                        strong {
                            min-width: 130px;
                            display: inline-block;
                        }
                    }
                }
                .project-feature-1 {
                    position: absolute;
                    display: none;
                    background-color: $color-grey;
                    width: 287px;
                    height: 253px;
                    background-size: cover;
                    background-position: center;
                    box-shadow: 0 5px 10px rgb(0 0 0 / 0.4);
                    top: 50px;
                    left: -34px;
                    

                    
                }
                .project-feature-2 {
                    position: absolute;
                    display: none;
                    background-color: $color-grey;
                    width: 328px;
                    height: 234px;
                    background-size: cover;
                    background-position: center;
                    box-shadow: 0 5px 10px rgb(0 0 0 / 0.4);
                    bottom: -46px;
                    top: auto;
                    left: 130px;
                }
            }
        }

        .banner-primary {
            
            .close-btn{

                position:absolute;
                display:block;
                width: 30px;
                height: 30px;
                background-position: center;
                background-repeat: no-repeat;
                background-size: 20px;
                background-image: url('#{$dir-images}icons/close.svg');
                cursor: pointer;

                right: 22px;
                top: 90px;

                @media #{$lg} {
                       top: -40px;
                }


            }

            .container {
                .col-content {
                    height: auto;
                    padding: 0px 0 60px 0;

                    @media #{$lg} {
                        padding: 0;
                    }
                }
            }
        }
    }

    img {
        display: block;
    }

    .fav {
            position: absolute;
            z-index: 3;
            display: block;
            width: 30px;
            height: 30px;
            background-image: url('#{$dir-images}icons/fav-dark.svg');
            background-position: center top;
            background-size: 100%;
            background-repeat: no-repeat;
            top: 5rem;
            right: 1rem;
            cursor:pointer;

             @media #{$lg} {
                        top: 1rem;
            }

            &.remove-fav {
                display: none;
                background-image: url('#{$dir-images}icons/fav-active-dark.svg');

                &.selected {
                    display: block;
    
                    &.remove {
                        background-image: url('#{$dir-images}icons/close.svg');
                    }
                }
            }

            &.add-fav {
                display: block;
                &.selected {
                    display: none;
                    
                }
            }

            &.selected {

                &.remove {
                    background-image: url('#{$dir-images}icons/close.svg');
                }
            }

            
        }

        .heading-holder {
            position: relative;
        }

    //@media #{$sm} {}
    //@media #{$md} {}
    //@media #{$lg} {}
    //@media #{$xl} {}


    .banner-colour-cta{
        display:block;
        margin : 0 auto;
        max-width: 210px;
        margin-bottom:10px;
        margin-top:0px;

        &:first-of-type{
            margin-top:16px;

        }

        @media #{$lg} {
                display: inline-block;
                margin-right: 2rem;
        
        }

      



    }

</style>
